module.exports = __webpack_public_path__ + "static/media/biteship-indah.4c46c93d.png";